/**
 * Card do dashboard do delegado: as contas em que ele atua, com o que está pendente
 * em cada uma (intimações não lidas e eventos da semana). Só contagens — o conteúdo
 * se vê entrando na conta (docs/PLANO_DELEGACAO.md, P10).
 */
import { ArrowRight, Bell, CalendarRange, UserCheck } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useDelegacoesRecebidas, useResumoRecebidas, useTrocarAtuacao } from '@/hooks/useDelegacoes';

export function ContasEmQueAtuoCard() {
  const { data: recebidas } = useDelegacoesRecebidas();
  const temRecebidas = (recebidas?.length ?? 0) > 0;
  const { data: resumo } = useResumoRecebidas(temRecebidas);
  const trocar = useTrocarAtuacao();
  if (!temRecebidas || !resumo || resumo.length === 0) return null;

  return (
    <Card>
      <CardContent className="p-4">
        <div className="mb-3 flex items-center gap-2">
          <UserCheck className="h-4 w-4 text-primary" />
          <h3 className="text-sm font-semibold">Contas em que você atua</h3>
        </div>
        <ul className="divide-y">
          {resumo.map((r) => {
            const item = recebidas!.find((d) => d.id === r.delegacao_id);
            return (
              <li key={r.delegacao_id} className="flex flex-wrap items-center justify-between gap-2 py-2.5">
                <div className="min-w-0">
                  <p className="break-words text-sm font-medium">{r.titular_nome}</p>
                  <p className="flex flex-wrap gap-x-3 text-xs text-muted-foreground">
                    <span className={r.intimacoes_nao_lidas > 0 ? 'font-medium text-primary' : undefined}>
                      <Bell className="mr-1 inline h-3 w-3" />
                      {r.intimacoes_nao_lidas} {r.intimacoes_nao_lidas === 1 ? 'intimação não lida' : 'intimações não lidas'}
                    </span>
                    <span>
                      <CalendarRange className="mr-1 inline h-3 w-3" />
                      {r.eventos_proximos_7_dias} {r.eventos_proximos_7_dias === 1 ? 'evento' : 'eventos'} em 7 dias
                    </span>
                  </p>
                </div>
                {item && (
                  <Button size="sm" variant="outline" className="min-h-[36px]" onClick={() => trocar(item)}>
                    Abrir
                    <ArrowRight className="h-4 w-4" />
                  </Button>
                )}
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
